import React, { Component } from 'react';


import { Form, Input, Button, Modal, Select, Divider, Icon } from 'antd';
import { withState } from 'recompose';
const FormItem = Form.Item;
const { Option } = Select;

class CamdetectCamerasPasswordForm extends Component {

    state = {
        modalVisible: false,
        confirmDirty: false,
    }

    form = null;

    componentWillReceiveProps(nextProps) {
        this.setState({
            modalVisible: nextProps.modalVisible
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSuccess(this.props.form, values);
            }
        });
    }

    handleConfirmBlur = e => {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('password')) {
            callback('Hesla si musí odpovídat!');
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirmPassword'], { force: true });
        }
        callback();
    };

    renderForm() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 11 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 22,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        return (
            <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
                <FormItem
                    {...formItemLayout}
                    label="Heslo">
                    {getFieldDecorator('password', {
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        },
                        { min: 8, message: 'Heslo musí mít minimálně 8 znaků.' },
                        {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        },
                        {
                            validator: this.validateToNextPassword,
                        }],
                    })(
                        <Input.Password />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Heslo pro kontrolu">
                    {getFieldDecorator('confirmPassword', {
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        },
                        {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        },
                        {
                            validator: this.compareToFirstPassword,
                        }],
                    })(
                        <Input.Password onBlur={this.handleConfirmBlur} />
                    )}
                </FormItem>
                {this.props.type && this.props.type !== 'modal'
                    ? <FormItem {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit">Uložit</Button>
                    </FormItem>
                    : null}
            </Form>
        );
    }

    render() {
        if (this.props.type && this.props.type === 'modal') {
            return (
                <Modal
                    className={'cstm-modal-form'}
                    width={700}
                    title="Změna hesla kamery"
                    visible={this.state.modalVisible}
                    maskClosable={false}
                    onCancel={() => {
                        this.props.onModalCancel(this.props.form);
                        this.setState({ modalVisible: false });
                    }}
                    okText="Uložit"
                    onOk={this.handleSubmit} >
                    {this.renderForm()}
                </Modal>
            )
        } else {
            return this.renderForm();
        }
    }
}

const WrappedCamdetectCameraPasswordForm = Form.create()(CamdetectCamerasPasswordForm);

export default WrappedCamdetectCameraPasswordForm;


// WEBPACK FOOTER //
// ./src/components/CamdetectCamerasPasswordForm.js